// src/components/Menu/Menu.tsx
import React, { useEffect, useState } from "react";
import { Flex } from 'antd'
import { useTranslation } from "react-i18next";
import styles from "./dataCarousel.module.css"

const DataCarousel = () => {
  const { t } = useTranslation();

  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    //Handle Responsiveness  
    const handleResize = () => {
      setWidth(window.innerWidth)
    }

    handleResize()

    // Bind the event listener
    window.addEventListener('resize', handleResize)

    return () => {
      // Unbind the event listener on clean up
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Flex wrap className={width > 1200 ? "menu-right-section" : styles.carouselContainer}>
      <div className={width > 1200 ? "innertxt1" : styles.carouselText}>
        <h2>{t('Σχετικά με το Έργο')}</h2>
        <p>{t('Η ενιαία διαδικτυακή πύλη «Μουσεία του Αποκόρωνα» σχεδιάστηκε και δημιουργήθηκε στο πλαίσιο του έργου «Ψηφιοποίηση Συλλογών Μουσείου Γαβαλοχωρίου», το οποίο υλοποιήθηκε από τον Δήμο Αποκορώνου. Στόχος του έργου είναι η προβολή και ανάδειξη των μουσείων του Δήμου Αποκορώνου και των εκθεμάτων τους στο ευρύ κοινό. Αναλυτικότερα, έλαβαν χώρα οι εξής εργασίες:')}</p>
        <ul>
          <li>{t('Ψηφιοποίηση - Φωτογράφηση των εκθεμάτων του Ιστορικού και Λαογραφικού Μουσείου Γαβαλοχωρίου: Οι συλλογές του μουσείου αποτυπώθηκαν ψηφιακά με υψηλής ανάλυσης φωτογραφίες, διασφαλίζοντας την πιστή αναπαράσταση κάθε εκθέματος.')}</li>
          <li>{t('Εισαγωγή των εκθεμάτων σε ψηφιακό αποθετήριο και τεκμηρίωση αυτών: Κάθε έκθεμα καταχωρήθηκε σε μια ψηφιακή βάση δεδομένων, συνοδευόμενο από σχετικές πληροφορίες.')}</li>
        </ul>
      </div>
          
      <div className={width > 1200 ? "innertxt1" : styles.carouselText}>
        <ul>
          <li>{t('Διασύνδεση των καταχωρημένων στο αποθετήριο εκθεμάτων με τη διαδικτυακή πύλη: Τα εκθέματα έγιναν προσβάσιμα μέσω της διαδικτυακής πύλης, επιτρέποντας στους επισκέπτες να τα εξερευνήσουν ψηφιακά.')}</li>
          <li>{t('Σχεδιασμός, προγραμματισμός και δημιουργία της ενιαίας Διαδικτυακής Πύλης «Μουσεία του Αποκόρωνα»: Αναπτύχθηκε μια φιλική προς τον χρήστη ιστοσελίδα που φιλοξενεί τα ψηφιοποιημένα εκθέματα, προσφέροντας δυνατότητες πλοήγησης και εξερεύνησης των μουσείων του Δήμου.')}</li>
        </ul>{t('Η σύμβαση για το παρόν έργο είχε διάρκεια έξι μηνών και έλαβε χρηματοδότηση από επιχορήγηση του Υπουργείου Πολιτισμού και Αθλητισμού. Το έργο αυτό αποτελεί ένα σημαντικό βήμα προς την ανάδειξη και διάσωση της πολιτιστικής κληρονομιάς του Δήμου Αποκορώνου, καθιστώντας την προσβάσιμη σε ένα ευρύτερο κοινό και συμβάλλοντας στη διατήρηση της ιστορικής μας μνήμης για τις επόμενες γενιές.')}
      </div>  
    </Flex>
  );
};

export default DataCarousel;
